import { useSyncExternalStore } from 'react';
import { getCaptionPreferenceSaveStatus, subscribeCaptionPreferenceSaveStatus } from './captionPreferences';
export default function useCaptionPreferenceSaveStatus() {
    return useSyncExternalStore(subscribeCaptionPreferenceSaveStatus, getCaptionPreferenceSaveStatus, getCaptionPreferenceSaveStatus);
}
